import { createGlobalStyle } from 'styled-components';

export const GlobalStyleOverride = createGlobalStyle`
    .header-is-open #onetrust-consent-sdk, .search-advisor-modal-open #onetrust-consent-sdk{
        display: none;
    } 


`;
